import getActiveByStaffMatrixRequest from "./requests/get-active-by-staff-matrix-request";
import getServicesRequest from "./requests/get-services-request";
import addCategoryRequest from "./requests/add-category-request";
import updateCategoryRequest from "./requests/update-category-request";
import deleteCategoryRequest from "./requests/delete-category-request";
import moveUpCategoryRequest from "./requests/move-up-category-request";
import addSubcategoryRequest from "./requests/add-subcategory-request";
import addServiceRequest from "./requests/add-service-request";
import updateServiceRequest from "./requests/update-service-request";
import deleteServiceRequest from "./requests/delete-service-request";
import moveUpServiceRequest from "./requests/move-up-service-request";
import moveUpModificationRequest from "./requests/move-up-modification-request";
import updateModificationRequest from "./requests/update-modification-request";
import deleteModificationRequest from "./requests/delete-modification-request";
import getLimitsRequest from "./requests/get-limits-request";

const servicesRepository = {
    getActiveByStaffMatrix: getActiveByStaffMatrixRequest,
    getServices: getServicesRequest,
    addCategory: addCategoryRequest,
    updateCategory: updateCategoryRequest,
    deleteCategory: deleteCategoryRequest,
    moveUpCategory: moveUpCategoryRequest,
    addSubcategory: addSubcategoryRequest,
    addService: addServiceRequest,
    updateService: updateServiceRequest,
    deleteService: deleteServiceRequest,
    moveUpService: moveUpServiceRequest,
    moveUpModification: moveUpModificationRequest,
    updateModification: updateModificationRequest,
    deleteModification: deleteModificationRequest,
    getLimits: getLimitsRequest,
};

export default servicesRepository;
